import React from 'react';
import { bool, string, func, arrayOf, shape } from 'prop-types';

import Forms from 'components/form-react-elements';

const AdvancedFilters = ({
    advancedFilters,
    handleAdvancedFiltersSelectChange,
    isLoading,
    title
}) => {
    if (!advancedFilters || !advancedFilters.length) {
        return null;
    }

    return (
        <div className="advanced-filters">
            {title && <h2 className="advanced-filters__title h4">{title}</h2>}
            {advancedFilters.map(
                ({ id, disabled, label, options, placeholder, value }) => (
                    <Forms.Select
                        key={id}
                        label={label}
                        disabled={disabled || isLoading}
                        labelIsBold
                        medium
                        name={id}
                        onChange={option =>
                            handleAdvancedFiltersSelectChange(option, id)
                        }
                        options={options}
                        placeholder={placeholder}
                        value={value}
                    />
                )
            )}
        </div>
    );
};

AdvancedFilters.propTypes = {
    advancedFilters: arrayOf(shape({})).isRequired,
    handleAdvancedFiltersSelectChange: func.isRequired,
    isLoading: bool,
    title: string
};

export default AdvancedFilters;
